import { render } from "./leader-advanced.vue?vue&type=template&id=035a0971"
import script from "./leader-advanced.vue?vue&type=script&lang=js"
export * from "./leader-advanced.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__